import { chunk } from 'lodash';

import { IngredientType } from '@libs/trip-planner-interfaces';
import type { AppSvgIconType } from '@libs/ui';
import { assertValue, exhaustiveGuard } from '@libs/utils';

export function getIconsChunks(
  ingredientTypes: IngredientType[]
): Array<Array<AppSvgIconType>> {
  function mapIngredientTypeToIcon(ingredient: IngredientType): AppSvgIconType {
    switch (ingredient) {
      case IngredientType.Hotel:
      case IngredientType.OwnStay:
        return 'bed';
      case IngredientType.Flight:
        return 'airplane';
      case IngredientType.Ferry:
        return 'ferry';
      case IngredientType.Activity:
        return 'activity';
      case IngredientType.Transport:
      case IngredientType.OwnTransport:
        return 'car';
      default:
        exhaustiveGuard(ingredient, '');
    }
  }
  const chunkSize = 5;
  const icons = ingredientTypes.map((ingredient: IngredientType) =>
    mapIngredientTypeToIcon(ingredient)
  );

  return chunk(icons, chunkSize);
}

export function getIconIndex(
  chunkIndex: number,
  iconIndex: number,
  chunkSize: number | undefined
): number {
  assertValue(chunkSize, 'helpers.ts > getIconIndex > chunkSize');

  if (iconIndex + 1 > chunkSize) {
    throw Error('Icon index cannot be larger than chunk size!');
  }

  if (chunkIndex === 0) {
    return iconIndex;
  }

  return chunkSize * chunkIndex + iconIndex;
}
